export default __webpack_public_path__ + "static/gcs-b8fd421019a4c7febd15ba4338f80566.png";